<script lang="ts">
  const butaneScrollerContent = ['Butane - Protocol', 'Butane - Protocol', 'Butane - Protocol']
</script>

<div class="maskEffect relative mx-auto self-center overflow-hidden whitespace-nowrap">
  <div
    class="flex w-max flex-wrap items-center gap-x-16 motion-safe:animate-collateral-options-scroll lg-desktop:space-x-28 lg-desktop:motion-safe:animate-butane-protocol-scroll-lg-desktop"
  >
    {#each butaneScrollerContent as item, index}
      <h2 class="gradient-text font-cirka uppercase tracking-wide">{item}</h2>
    {/each}
  </div>
</div>

<style lang="postcss">
  .gradient-text {
    background: linear-gradient(to bottom, #252935 20%, #0a0a0c 70%, #050505 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-size: 96px;
    font-weight: 700;
    padding: 4rem 0;
  }

  @media (min-width: 1440px) {
    .gradient-text {
      font-size: 360px;
      padding: 12rem 0;
    }
  }
</style>
